import { useQuery } from "@tanstack/react-query"
import { apiGET } from "data/api/get"

/**
 * Returns a list of project slugs that have data for a given metric.
 * e.g. https://api.tokenterminal.com/v3/internal/metrics/fees/project-availability
 * @example
 * const { data: projectAvailability } = useAvailableProjectSlugsForMetric("fees")
 */

export const useAvailableProjectSlugsForMetric = (metricSlug: string) => {
  return useQuery({
    queryKey: ["metric-project-availability", metricSlug],
    queryFn: async () => {
      const result = await apiGET(
        `/v3/internal/metrics/${metricSlug}/project-availability` as "/v3/internal/metrics/:slug/project-availability"
      )
      return result.data.map((project) => project.slug)
    },
    staleTime: 1000 * 60 * 10,
  })
}
